import React, { useEffect, useState } from "react";
import styled from "styled-components";

function Test(props) {
    const [count, setCount] = useState(0);

    useEffect(() => {
        setInterval(() => {
            setCount((prev) => prev + 1);
        }, 1000);
    }, []);

    return <Wrapper>{count}</Wrapper>;
}

export default Test;

const Wrapper = styled.div``;
